import React from "react";
import useSeo from "../seo/useSeo";

export default function Confidentialite() {
  useSeo({
    title: "Politique de confidentialité | pdf-convert.fr",
    description:
      "Politique de confidentialité : traitement local des fichiers, cookies et publicités.",
    canonical: "https://pdf-convert.fr/confidentialite",
  });

  return (
    <main style={{ maxWidth: 900, margin: "0 auto", padding: 16 }}>
      <h1>Politique de confidentialité</h1>

      <p>
        La présente politique de confidentialité informe les utilisateurs du
        site <b>pdf-convert.fr</b> sur la manière dont les données sont
        traitées.
      </p>

      <h2>1. Données personnelles</h2>
      <p>
        Le site <b>pdf-convert.fr</b> ne collecte aucune donnée personnelle
        identifiable sans consentement explicite.
      </p>

      <h2>2. Traitement des fichiers</h2>
      <p>
        Les fichiers (PDF, images) traités via les outils proposés sont traités{" "}
        <b>exclusivement dans le navigateur</b> de l’utilisateur.{" "}
        <b>Aucun fichier n’est envoyé, stocké ou conservé sur nos serveurs.</b>
      </p>

      <h2>3. Cookies</h2>
      <p>
        Le site peut utiliser des cookies à des fins de mesure d’audience, de
        sécurité et de diffusion de publicités via Google AdSense.
      </p>

      <h2>4. Google AdSense</h2>
      <p>
        Google, en tant que fournisseur tiers, utilise des cookies pour diffuser
        des annonces adaptées aux utilisateurs en fonction de leur navigation.
        L’utilisateur peut gérer ou désactiver les cookies via les paramètres de
        son navigateur.
      </p>

      <h2>5. Sécurité</h2>
      <p>
        Aucune donnée personnelle sensible n’est stockée sur le site. Les
        conversions sont effectuées localement sur l’appareil de l’utilisateur.
      </p>

      <h2>6. Contact</h2>
      <p>
        Pour toute question :{" "}
        <a href="mailto:contact@pdf-convert.fr">contact@pdf-convert.fr</a>
      </p>
    </main>
  );
}
